import type { StockApi } from "../../api/StockApi";
import type { CatalogItemInstanceFetchOptions } from "../../generated/dto/CatalogItemInstanceFetchOptions";
import type { CatalogItemInstanceStaff } from "../../generated/dto/CatalogItemInstanceStaff";
import type { CreateStockChange } from "../../generated/dto/CreateStockChange";
import type { DeleteStockChangeStaff } from "../../generated/dto/DeleteStockChangeStaff";
import type { StaffStockSummary } from "../../generated/dto/StaffStockSummary";
import type { StockAdjustRequest } from "../../generated/dto/StockAdjustRequest";
import type { StockChangeFetchOptions } from "../../generated/dto/StockChangeFetchOptions";
import type { StockChangeStaff } from "../../generated/dto/StockChangeStaff";
import type { UpdateStockChange } from "../../generated/dto/UpdateStockChange";

export class StockFrontendService {
  constructor(private readonly api: StockApi) {}
  async getStockChangeStaff(id: number, options?: StockChangeFetchOptions): Promise<StockChangeStaff> {
    return this.api.getStockChangeStaff(id, options)
  }
  async createStockChangeStaff(source: CreateStockChange): Promise<StockChangeStaff> {
    return this.api.createStockChangeStaff(source)
  }
  async updateStockChangeStaff(source: UpdateStockChange): Promise<StockChangeStaff> {
    return this.api.updateStockChangeStaff(source)
  }
  async deleteStockChangeStaff(source: DeleteStockChangeStaff): Promise<void> {
    return this.api.deleteStockChangeStaff(source)
  }
  async getStockChangeStaffItemInstanceId(id: number, options?: CatalogItemInstanceFetchOptions): Promise<CatalogItemInstanceStaff> {
    return this.api.getStockChangeStaffItemInstanceId(id, options)
  }
  async adjustStockStaff(request: StockAdjustRequest): Promise<StaffStockSummary> {
    return this.api.adjustStockStaff(request)
  }
  async stockSummaryStaff(): Promise<Array<StaffStockSummary>> {
    return this.api.stockSummaryStaff()
  }
}
